module.exports = function (manager_self) {
  var container = String(manager_self.container || '');
  var inOverlay = container.includes('chat-manager-overlay');
  var inChatPage = container.includes('chat-page-manager-content');
  var settingsBtn = "<div class=\"chat-manager-options\"><i class=\"fa-solid fa-ellipsis\"></i></div>";
  var closeBtn = "<div class=\"alternate-close-button\"><i class=\"fa-solid fa-xmark\"></i></div>";
  var actionsInner = settingsBtn;
  if (inOverlay) {
    var overlay = typeof document !== 'undefined' ? document.querySelector('.chat-manager-overlay') : null;
    var floating = overlay === null || overlay === void 0 ? void 0 : overlay.classList.contains('floating-cm-overlay');
    if (floating) {
      // Desktop floating overlay — X only (settings were hidden here)
      actionsInner = closeBtn;
    } else {
      // Mobile overlay navigation lives in the persistent bottom action bar.
      actionsInner = '';
    }
  } else if (inChatPage) {
    actionsInner = '';
  }
  var header = inChatPage ? '' : "<div id=\"chat-manager-header\" class=\"saito-sidebar-header chat-manager-header\">\n      <div class=\"title chat-manager-title\" title=\"Recent contacts and secure conversations\">Contacts</div>\n      <div class=\"actions\">".concat(actionsInner, "</div>\n    </div>");
  return "\n  <div class=\"chat-manager\">\n    ".concat(header, "\n    <div class=\"chat-manager-list hide-scrollbar saito-menu-select-heavy").concat(manager_self.mod.browser_active ? '' : ' saito-sidebar-element', "\">\n    </div>\n  </div>");
};